import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, of} from 'rxjs';
import {ReloadRouteUtilityService} from '@app/services/reload-route/reload-route-utility.service';
import {PageId} from '@app/constants/page-id';
import {PasswordService} from '@app/services/password/password.service';
import { ComponentNameService } from '@app/services/component-name.service';

@Injectable({
  providedIn: 'root',
})
export class AppRouteGuardHome  {
  constructor(
    private router: Router,
    private reloadRouteUtilityService: ReloadRouteUtilityService,
    private passwordService: PasswordService,
    private componentNameService: ComponentNameService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.reloadRouteUtilityService.storeCurrentUrlInSessionStorage(state.url);

    if(this.passwordService.isViewer()) {
        this.router.navigate([PageId.fenceResultAudience]);
      }

    this.componentNameService.currentComponentName = next.component.name;
    return of(true);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.reloadRouteUtilityService.storeCurrentUrlInSessionStorage(state.url);
    return of(true);
  }

}
